var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHankkija(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 274.2 109.62",
    style: {
      enableBackground: "new 0 0 274.2 109.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#849938;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,67.8h11.88l2.82-14.76h10.98l-7.74,40.5H22.62l3.06-15.96H13.8l-3.06,15.96H0l6.12-32.22 c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54L15.6,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.02,93.54c0,0-1.74,0.12-6.6,0.12c-1.26,0-2.52,0-3.78-0.06c0.48-2.04,0.9-3.66,1.74-5.7h-0.12 c-2.82,4.2-6.36,6.42-10.5,6.42c-4.92,0-7.5-3.18-7.5-9.72C40.26,72.96,46.86,63,60,63c3.9,0,8.22,0.24,12.36,1.02 C68.64,83.22,67.02,93.54,67.02,93.54z M58.08,71.58c-4.08,0-6.72,6.36-6.72,10.92c0,1.56,0.24,2.34,1.14,2.34 c2.28,0,6.42-6.72,7.38-11.7l0.24-1.26C59.52,71.7,58.92,71.58,58.08,71.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.18,93.54H91.44l3.48-18.18c0.42-2.22,0.18-2.94-0.6-2.94c-1.86,0-6.18,6-7.38,12.24l-1.68,8.88H74.52 l4.14-21.48v-0.12c-1.38-0.24-3.36-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.38-0.72,15.42-0.54c-0.3,1.5-0.78,3.48-1.8,5.7h0.12 c2.64-3.84,5.94-6.42,10.8-6.42c6.12,0,7.68,4.38,6.66,9.66L102.18,93.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.78,77.76l6.48,15.78h-12.9l-3.9-13.8l-2.64,13.8h-10.74l6.72-35.4l0.06-0.18 c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54l-4.86,25.5l11.46-13.62l8.76,5.22L132.78,77.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.96,77.76l6.48,15.78h-12.9l-3.9-13.8L153,93.54h-10.74l6.72-35.4l0.06-0.18 c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54l-4.86,25.5l11.46-13.62l8.76,5.22L165.96,77.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.3,93.54h-10.74l4.14-21.48v-0.12c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14 c4.98-0.54,10.32-0.72,16.02-0.54L189.3,93.54z M190.8,61.44c-3.66,0-6.12-2.82-6.12-5.88c0-3.9,3.36-6.72,6.96-6.72 c3.6,0,6.12,2.82,6.12,5.76C197.76,58.62,194.4,61.44,190.8,61.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.26,94.26c-1.56,8.1-6.06,13.68-15.78,13.68c-1.44,0-3-0.24-4.26-0.6l2.28-9.18 c0.96,0.42,2.1,0.6,2.88,0.6c2.22,0,3.48-1.32,4.2-4.92l4.26-21.78v-0.12c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14 c4.98-0.54,10.32-0.72,16.02-0.54L208.26,94.26z M209.94,61.44c-3.66,0-6.12-2.82-6.12-5.88c0-3.9,3.36-6.72,6.96-6.72 c3.6,0,6.12,2.82,6.12,5.76C216.9,58.62,213.54,61.44,209.94,61.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.73,93.54c0,0-1.74,0.12-6.6,0.12c-1.26,0-2.52,0-3.78-0.06c0.48-2.04,0.9-3.66,1.74-5.7h-0.12 c-2.82,4.2-6.36,6.42-10.5,6.42c-4.92,0-7.5-3.18-7.5-9.72c0-11.64,6.6-21.6,19.74-21.6c3.9,0,8.22,0.24,12.36,1.02 C243.35,83.22,241.73,93.54,241.73,93.54z M232.8,71.58c-4.08,0-6.72,6.36-6.72,10.92c0,1.56,0.24,2.34,1.14,2.34 c2.28,0,6.42-6.72,7.38-11.7l0.24-1.26C234.24,71.7,233.64,71.58,232.8,71.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.14,22.79C270.48,15.4,273.04,4.46,274.2,0c-2.89,3.98-9.35,6.39-13.5,7.4 c-3.78,0.92-11.1,1.93-18.09,5.3c-6.95,3.34-9.73,9.03-11.77,13.37c-2.24,4.77-3.49,12.29-3.49,12.29 C235.44,28.98,240.75,28.08,253.14,22.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.24,30.52c-17.33,7.4-19.9,18.34-21.06,22.8c2.9-3.98,9.35-6.39,13.5-7.39c3.78-0.92,11.1-1.93,18.09-5.3 c6.95-3.34,9.73-9.03,11.77-13.37c2.24-4.77,3.49-12.3,3.49-12.3C262.94,24.34,257.63,25.24,245.24,30.52z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHankkija);
export default __webpack_public_path__ + "static/media/Hankkija.6463785e6ec42c82ac8afd90ee76acec.svg";
export { ForwardRef as ReactComponent };